<app-page-title title="Membro"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<div class="search-container">
  <input class="search-input" placeholder="Buscar..." [(ngModel)]="searchValue" autocomplete="off" #input />
  <div class="search-img">
    <img src="../../../assets/icons/search-white.svg" sizes="1" (click)="search(input.value)" />
  </div>
</div>
<br />
<app-no-data *ngIf="members.length == 0" title="Sem dados" subtitle=" Nenhum membro cadastrado"></app-no-data>

<div>
  <cdk-virtual-scroll-viewport itemSize="95" class="example-viewport" (scrolledIndexChange)="scroll($event)">
    <div *cdkVirtualFor="let member of members">
      <app-member-card [member]="member" [showActions]="true"></app-member-card>
    </div>
  </cdk-virtual-scroll-viewport>
</div>

<div class="example-button-container">
  <button mat-fab color="primary" aria-label="Example icon button with a delete icon" [routerLink]="['/membro/add']">
    <img src="../../../assets/icons/add_white_24dp.svg" />
  </button>
</div>
